"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tile = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cdsCommon = require("@cbhq/cds-common");
var _useScaleConditional = require("@cbhq/cds-common/scale/useScaleConditional");
var _tile = require("@cbhq/cds-common/tokens/tile");
var _DotCount = require("../dots/DotCount");
var _VStack = require("../layout/VStack");
var _typography = require("../typography");
var _overflow = require("../utils/overflow");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * @danger this component is for internal use only
 */
const Tile = /*#__PURE__*/(0, _react.memo)(({
  title,
  count,
  showOverflow,
  children
}) => {
  const _useToggler = (0, _cdsCommon.useToggler)(false),
    shouldOverflow = _useToggler[0],
    toggleShouldOverflow = _useToggler[1];
  const overflowTextStyles = (0, _overflow.getOverflowTextStyles)(showOverflow !== undefined ? showOverflow : shouldOverflow);
  const tileSize = (0, _useScaleConditional.useScaleConditional)({
    dense: _tile.denseTileSize,
    normal: _tile.tileSize
  });
  const handleShowOverflow = (0, _react.useCallback)(() => {
    if (showOverflow === undefined) {
      toggleShouldOverflow.toggleOn();
    }
  }, [toggleShouldOverflow, showOverflow]);
  const handleHideOverflow = (0, _react.useCallback)(() => {
    if (showOverflow === undefined) {
      toggleShouldOverflow.toggleOff();
    }
  }, [toggleShouldOverflow, showOverflow]);

  /* If count is provided, wrap the children in a DotCount */
  const renderContent = (0, _react.useMemo)(() => {
    return count ? /*#__PURE__*/_react.default.createElement(_DotCount.DotCount, {
      count: count,
      pin: "top-end"
    }, children) : children;
  }, [children, count]);
  return /*#__PURE__*/_react.default.createElement(_VStack.VStack, {
    alignItems: "center",
    gap: 1,
    justifyContent: "center",
    onMouseEnter: handleShowOverflow,
    onMouseLeave: handleHideOverflow,
    spacing: 1,
    width: tileSize
  }, /*#__PURE__*/_react.default.createElement(_VStack.VStack, {
    alignItems: "center",
    justifyContent: "center"
  }, renderContent), /*#__PURE__*/_react.default.createElement(_typography.TextLabel2, {
    align: "center",
    as: "p",
    className: overflowTextStyles
  }, title));
});
exports.Tile = Tile;